import React, { Component } from 'react';
import { has,map} from 'lodash';
import DriverEmergencyHeader from './DriverEmergencyHeader';
import DriverEmergencyDisplayOnMap from './DriverEmergencyDisplayOnMap';
import Gmaps from '../common/Gmaps';
import AddUserPopUp from '../MyVehicles/AddUserPopUp.jsx';
import { imageBasePath } from '../../constants/staticData';




export default class DriverEmergencyAceptDecline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEmergencyrequest: ''
        };
    }

    componentWillReceiveProps(next) {
    //this.props.actions.getDriverEmergencyInfo();
      let selectedDataInfo = '';
      let queueInfo = this.props.driveremergencyReducer.driveremergencyinfo.data;
      if(queueInfo) {
        if(queueInfo.length > 0 ) {
            map(queueInfo, (info) => {
              if(info.garagejobquotes.userbookingrequest.requestid == this.props.params.id) {
                selectedDataInfo = info;
              }
            });
            this.setState({selectedEmergencyrequest: selectedDataInfo});
          }
        }
    }

    render() {
     const {authReducer, commonReducer,driveremergencyReducer} = this.props;
     const emergencyName = (this.state.selectedEmergencyrequest ? this.state.selectedEmergencyrequest.garagejobquotes.garagejobquotesdetail[0].name : '');
            return (
        <div>
        {/*<DriverEmergencyHeader/>*/}
        
            <div className="container-fluid">
              <div className="row clearfix">

                <AddUserPopUp showpopupType='driver-decline' manageVehicle={this.props.manageuserReducer} jobSelectedData= {this.state.selectedEmergencyrequest} actions={this.props.actions} router={this.props.router}> </AddUserPopUp>
              <DriverEmergencyHeader commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification}
               router={this.props.router} displayName={emergencyName} displayLogo="false" driveremergencyReducer={driveremergencyReducer}/>
               {this.state.selectedEmergencyrequest != '' &&
               <div className="driver-emergency-list-container">
                 <div className="">
                   <Gmaps
                    center={{
                          lat: Number(this.state.selectedEmergencyrequest.garagejobquotes.userbookingrequest.latitude),
                          lng: Number(this.state.selectedEmergencyrequest.garagejobquotes.userbookingrequest.longitude)
                         }}
                  zoom={10}
                   marker={{ "position": { lat: Number(this.state.selectedEmergencyrequest.garagejobquotes.userbookingrequest.latitude), lng: Number(this.state.selectedEmergencyrequest.garagejobquotes.userbookingrequest.longitude),draggable: false } }}
                   draggable={false}                
                   currentmarker={{ "position": { lat: Number(driveremergencyReducer.dpositioninfo.latitude), lng: Number(driveremergencyReducer.dpositioninfo.longitude) } }}
                   currentImage={driveremergencyReducer.navigationflag ? `${imageBasePath}/map_blue_pointer.png` : ''}
                   pinImage={`${imageBasePath}/drag-loc.png`}
                   containerElement={<div style={{ height: "auto", width: 100 + '%' }} />}
                   mapElement={<div style={{ height: (window.screen.availHeight-80) + 'px', width: 100 + '%' }} />}/>
                 </div>
                 <DriverEmergencyDisplayOnMap {...this.props} selectedData={this.state.selectedEmergencyrequest} driverid={this.props.params.id} routes={this.props.routes} flowType='acceptDecline'/>
                </div>
              }
                
              </div>
            </div>
            
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyAceptDecline.jsx